import React, { useEffect, useState } from 'react'
import Input from '../../components/input';
import useAxiosInstance from '../../hooks/useAxios';

import { TableCustom } from '../../components/Table';
import { BREAK_POINT_TABLE_SETTINGS } from '../../helper';
import { FaFile, FaFolder } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';

const Breakpoints = () => {
    const [reportLink, setReportLink] = useState("")
    const [loading, setIsLoading] = useState(false)
    const axiosInstance = useAxiosInstance();
    const [response, setResponse] = useState([]);
    const [currentDirectory, setCurrentDirectory] = useState("");
    const [searchParams, setSearchParams] = useSearchParams()
    const [IsXLSXDownloading, setIsXLSXDownloading] = useState([]);
    const [continuationToken, setContinuationToken] = useState(null);
    const [mode, setMode] = useState('breakpoint');

    React.useEffect(() => {
        setSearchParams(param => param.set('currentDirectory', currentDirectory))
    }, [currentDirectory])

    const handleDownload = async (givenUrl, name, setIsXLSXDownloading, fileType) => {
        setIsXLSXDownloading(prev => [...prev, givenUrl]);

        await axiosInstance.post('/assets/download_renamed_file/', {
            "filename": name,
            "filetype": fileType,
            "url": givenUrl
        },
            {
                responseType: "blob",
            })
            .then((response) => {
                console.log(IsXLSXDownloading, givenUrl)
                setIsXLSXDownloading(prev => prev.filter(item => item !== givenUrl));
                const url = window.URL.createObjectURL(
                    new Blob([response.data], { type: "application/" + fileType })
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    name
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                setIsXLSXDownloading(prev => prev.filter(item => item !== givenUrl))
            });
    };

    return (
        <div>
            <div className="mr-4  p-3 my-5 border rounded-lg bg-white">
                <p className="text-2xl text-black font-medium mb-4">Breakpoints</p>
                <div className="rounded-xl bg-gray-100 p-3">
                    <p className="text-sm font-semibold text-black mb-2">
                        Report Link
                    </p>
                    <div>
                        <Input
                            type={"text"}
                            value={reportLink}
                            onChange={(e) => {
                                setReportLink(e.target.value);
                            }}
                        />
                        <div>
                            <div className="text-sm font-semibold mb-2">Mode</div>
                            <select
                                className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"
                                value={mode}
                                onChange={(e) => {
                                    setMode(e.target.value);
                                }}
                            >
                                <option value={"breakpoint"}>Breakpoint</option>
                                <option value={"all"}>all</option>
                            </select>
                        </div>
                    </div>
                    <button
                        disabled={loading}
                        onClick={() => {
                            setContinuationToken(null)
                            setResponse([]);
                            setIsLoading(true);
                            axiosInstance
                                .post("/assets/get_report_breakpoints/", {
                                    report_link: reportLink,
                                    continuation_token: null,
                                    mode: mode
                                })
                                .then((res) => {
                                    setIsLoading(false);
                                    setResponse(res.data.data);
                                    setCurrentDirectory(res.data.directory_path)
                                    setContinuationToken(res.data.continuation_token)
                                })
                                .catch((err) => {
                                    setIsLoading(false);
                                    setResponse([]);
                                    console.log(err?.response?.data?.message);
                                });
                        }}
                        className="text-sm bg-black disabled:cursor-not-allowed text-white font-medium px-2 py-1 rounded-md mt-2"
                    >Fetch</button>
                </div>
                <p className={"text-xs font-medium my-3"}>Current Directory: {currentDirectory}</p>
                <div className='mt-4'>
                    {loading ? <p>Loading...</p> :
                        response?.map((rt) => {
                            return <div className='grid  items-center mb-2 grid-cols-3' key={rt.name}>
                                <div className='flex gap-x-2 items-center'><p>{rt.is_directory ? <FaFolder /> : <FaFile />}</p>
                                    <p className='text-xs font-semibold'>{rt.name}</p>
                                </div>
                                {rt.last_modified &&
                                    <div className='flex gap-x-2 items-center'>
                                        <p className='text-xs font-semibold'>{rt.last_modified}</p>
                                    </div>
                                }
                                {rt.is_directory && <div></div>}
                                {
                                    <div className=' flex w-full justify-end '>
                                        <p>
                                            {
                                                !rt.path ?
                                                    <button
                                                        disabled={loading}
                                                        onClick={() => {
                                                            setResponse([]);
                                                            setContinuationToken(null)
                                                            setIsLoading(true);
                                                            axiosInstance
                                                                .post("/assets/get_report_breakpoints/", {
                                                                    report_link: reportLink,
                                                                    given_directory_path: `${currentDirectory}${rt.name}/`,
                                                                    continuation_token: null,
                                                                    mode: mode
                                                                })
                                                                .then((res) => {
                                                                    setIsLoading(false);
                                                                    setResponse(res.data.data);
                                                                    setCurrentDirectory(res.data.directory_path)
                                                                    setContinuationToken(res.data.continuation_token)
                                                                })
                                                                .catch((err) => {
                                                                    setIsLoading(false);
                                                                    setResponse([]);
                                                                    console.log(err?.response?.data?.message);
                                                                });
                                                        }}
                                                        className="px-3 py-1 disabled:bg-white disabled:text-black text-xs bg-black rounded-md text-white"
                                                    >Fetch</button>
                                                    :
                                                    <div>
                                                        {/* <button
                                                        disabled={IsXLSXDownloading?.includes(rt.path)}
                                                        className="px-3 py-1 disabled:bg-white disabled:text-black text-xs bg-black rounded-md text-white"
                                                        onClick={() => handleDownload(rt.path, rt.name, setIsXLSXDownloading, rt.name?.split('.')?.pop())}>
                                                        {IsXLSXDownloading?.includes(rt.path) ? 'Loading' : 'Download'}
                                                    </button> */}
                                                        <button
                                                            className="px-3 py-1 disabled:bg-white disabled:text-black text-xs bg-black rounded-md text-white"
                                                            onClick={() => window.open(rt.path, '_blank')}>
                                                            Open
                                                        </button>
                                                    </div>
                                            }
                                        </p>
                                    </div>
                                }
                            </div>
                        })}
                </div>
                {continuationToken !== null &&
                    <button
                        onClick={() => {
                            setIsLoading(true);
                            axiosInstance
                                .post("/assets/get_report_breakpoints/", {
                                    report_link: reportLink,
                                    given_directory_path: `${currentDirectory}`,
                                    continuation_token: continuationToken,
                                    mode: mode
                                })
                                .then((res) => {
                                    setIsLoading(false);
                                    setResponse(prev => [...prev, ...res.data.data]);
                                    setCurrentDirectory(res.data.directory_path)
                                    setContinuationToken(res.data.continuation_token)
                                })
                                .catch((err) => {
                                    setIsLoading(false);
                                    setResponse([]);
                                    console.log(err?.response?.data?.message);
                                });
                        }}
                        className={"text-sm font-semibold px-1 py-1"}>More</button>}
            </div>
        </div>
    )
}

export default Breakpoints